import { useState } from "react";

interface UseControlPanelStateOptions {
  /** Current visualization type */
  vizType: string;
  /** Optional callback for analytics when settings panel opens */
  onSettingsOpen?: () => void;
}

export const useControlPanelState = (options?: UseControlPanelStateOptions) => {
  const [isSettingsOpen, setIsSettingsOpen] = useState<boolean>(false);

  const toggleSettingsPanel = () => {
    const newIsSettingsOpen = !isSettingsOpen;
    setIsSettingsOpen(newIsSettingsOpen);
    if (newIsSettingsOpen && options?.onSettingsOpen) {
      options.onSettingsOpen();
    }
  };

  return {
    isSettingsOpen,
    setIsSettingsOpen,
    toggleSettingsPanel,
  };
};
